import styled from 'styled-components';

export const ApplicantDocumentsTitle = styled.h2`
  font-size: ${(props) => props.theme.typography.size.sm3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.md2}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};
`;

export const NormalText = styled.p<{ margin?: string }>`
  font-size: ${(props) => props.theme.typography.size.sm1}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm3}px;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  color: ${(props) => props.theme.colors.textGray};
  ${(props) => props.margin && `margin: ${props.margin}`};
`;
export const HighlightedText = styled.p`
  font-size: ${(props) => props.theme.typography.size.sm2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};
  margin: 0;
`;

export const SectionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  button {
    max-width: 169px;
    font-size: ${(props) => props.theme.typography.size.sm2}px;
    line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  }
`;

export const DocumentListView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
`;

export const UploadedFileWrap = styled.div`
  display: flex;
  flex-direction: row;

  svg {
    position: relative;
    left: 22px;
    top: 15px;
  }
  svg:hover {
    cursor: pointer;
  }
`;

export const UploadedFile = styled.div`
  border: 2px solid #dee2e6;
  border-radius: 8px;
  padding: 10px;
  height: 48px;
  max-width: 169px;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  font-weight: 500;
  text-decoration: underline;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  & p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & svg:hover {
    cursor: pointer;
  }
`;

export const FileInputRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: nowrap;
  align-items: center;
`;

export const TitleText = styled.h3`
  margin-left: 16px;
`;
